import React, { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'
import colors from '../lib/colors'
import { IColorTheme } from '../types/itemTypes'

const Styles = styled.div`
  background-color: ${colors.white};
  padding: 4px 10px;
  min-height: 30px;
  border: 1px solid ${colors.darkestGray};
  cursor: pointer;
  display: flex;
  align-items: center;
  :hover {
    background-color: ${(props): string => props.theme.colourHighlight};
    color: ${(props): string => props.theme.colourTextOnHighlight};
  }
  &.active {
    background-color: ${(props): string => props.theme.colourHighlight};
    color: ${(props): string => props.theme.colourTextOnHighlight};
  }
`
interface GridButtonProps {
  theme?: Partial<IColorTheme>
  onClick?: () => void
  className?: string
  children?: ReactNode
}
export default function GridButton(props: GridButtonProps): ReactElement {
  const {
    theme, onClick, className, children,
  } = props

  return (
    <Styles theme={theme} onClick={onClick} className={className}>
      {children}
    </Styles>
  )
}
